import nearestPoint from '@turf/nearest-point';
import _ from 'lodash';
import * as ActionTypes from '../actions/actionTypes';
import overlayConfig from '../config/overlays';
import {AEROLOGICAL_WS} from '../Constants';

const initialState = { geo_json: null, aqfx_geo_json: null, active: null };

const getAerologicaExternallUrl = (stationId) => {
  const aws_overlay = _.keyBy(overlayConfig, 'id')['AWS'];
  return aws_overlay.config.aerologicalExternalLinkUrl.replaceAll('{stationId}', stationId);
};

const getAwsExternalUrl = (stationId) => {
  const aws_overlay = _.keyBy(overlayConfig, 'id')['AWS'];
  return aws_overlay.config.awsExternalLinkUrl.replaceAll('{stationId}', stationId);
};

const isClose = (a, b) => {
  return Math.abs(b.geometry.coordinates[0] - a.geometry.coordinates[0]) < 0.005 &&
         Math.abs(b.geometry.coordinates[1] - a.geometry.coordinates[1]) < 0.005;
};

const combineAqfxData = (awsData, aqfxData) => {
  if (awsData === null || aqfxData === null) {
    return awsData;
  }

  awsData.features.forEach(feature => {
    const aqfx = _.find(aqfxData.features, (a) => isClose(feature, a));
    if (aqfx && aqfx.properties.f160) {
      feature.properties.isAqfx = true;
      feature.properties.aqfxId = aqfx.properties.fid;
      aqfx.found = true;
    }

    if (AEROLOGICAL_WS.includes(feature.properties.stationid)) {
      feature.properties.hasActualAerologicalDiagram = true;
    }
  });

  awsData.aqfxLoaded = true;

  return awsData;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.POPULATE_AWS_DATA:
      return {
        ...state,
        geo_json: combineAqfxData(_addType(action.data), state.aqfx_geo_json)
      };

    case ActionTypes.POPULATE_AQFX_DATA:
      return {
        ...state,
        geo_json: combineAqfxData(state.geo_json, action.data),
        aqfx_geo_json: action.data
      };

    case ActionTypes.SET_ACTIVE_POINT:
    case ActionTypes.FIND_NEAREST_AWS:
      let active;
      if (state.geo_json && action.latlng) {
        const nearest = nearestPoint([action.latlng.lng, action.latlng.lat], state.geo_json).properties;
        // Ignore if outside 10km
        if (nearest.distanceToPoint < 10) {
          active = nearest;
          nearest.distanceToPoint = Math.round(nearest.distanceToPoint);
          nearest.awsExternalUrl = getAwsExternalUrl(nearest.stationid);
          nearest.aerologicaExternallUrl = getAerologicaExternallUrl(nearest.stationid);
        }
      }
      return {
        ...state,
        active
      };

    default:
      return state;

  }
};

const _addType = (data) => {
  data.features.forEach(feature => {
    feature.properties.isAutoWS = !feature.properties.description.includes('NON-AWS');
  });
  return data;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/aws.js